import { mapValues } from "lodash"
import { createTransform, persistReducer } from "redux-persist"
import storage from "redux-persist/es/storage"
import { DAMAGE_CASE_DEFAULTS } from "../features/damage-case/redux/initialState"

const noInbound = (state, _key) => state
const noOutboud = (state, _key) => state

const resetPending = (state, key) => {
  switch (key) {
    case "auth":
      return { ...state, fetchUserinfoPending: false, loginPending: false }

    case "common":
      return { ...state, fetchCodeTablesPending: false }

    case "damageCase":
      return { ...state, submitCasePending: [] }

    case "home":
      return { ...state, fetchAllLgPending: false, fetchLgDetailPending: [], updateCurrentLocationPending: false }

    default:
      return state
  }
}

const migrateUnsentCases = (state, key) => {
  switch (key) {
    case "damageCase":
      return { ...state, unsentCases: mapValues(state.unsentCases, migrateDamageCase) }

    default:
      return state
  }
}

const migrateDamageCase = damageCase => ({ ...DAMAGE_CASE_DEFAULTS, ...damageCase })

const persistConfig = {
  key: "root",
  blacklist: ["router"],
  storage,
  transforms: [createTransform(noInbound, resetPending), createTransform(migrateUnsentCases, noOutboud)],
}

export function addPersistence(reducer) {
  return persistReducer(persistConfig, reducer)
}



// WEBPACK FOOTER //
// ./src/common/configPersistence.js